import e from "@dialpad/dialtone-tokens/layered/themes/tokens-122-colors.css?inline";
//#region themes/122.js
var t = { brand: {
	css: e,
	name: "122"
} };
//#endregion
export { t as default };
